import React, { Component } from 'react';
import { apiGet } from '../../Api';
import './ItemModal.css';
import { ImageLoader } from '../Game/ImageLoader';





export default class ItemsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
        };
    }

    componentDidMount() {
        this.getItems();

    }
    componentWillUnmount() {

    }





    getItems = async () => {
        const response = await apiGet("/item");
        if (response.ok) {
            const items = await response.json();
            this.setState({ items });
        }
    };



    render() {
        const { items } = this.state;
        const { onSelect, onClose } = this.props;

        return (
            <div className="modal">
                <div className="modal-content">
                    <span className="close" onClick={onClose}>&times;</span>
                    <div className="grid-container">
                        {items?.map(item => (
                            <div key={item.id} onClick={() => onSelect(item)} className='gridItem'>
                                <ImageLoader
                                    imageId={item.imageId}
                                    animatedMediaId={item.animatedMediaId || item.animatedImageId}
                                    alt={item.name}
                                    title={item.name}
                                    size="small"
                                />


                                <p>{item.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}
